import * as S from '../styles';
import { FieldRendererProps } from '../types';

const HeaderField = ({ field }: FieldRendererProps) => (
  <S.HeaderElement>{field.label}</S.HeaderElement>
);

export default HeaderField;
